export default __webpack_public_path__ + "static/media/logowhiteBlirok.52a7c055.png";